import React from 'react';
import Helmet from 'react-helmet';
import { BreadCrumbs } from '../components/BreadCrumbs';
import { Contacts } from '../components/Contacts';
import {
  email,
  phones,
  address,
  coordinates
} from '../data';

const ContactsRoute = () => (
  <>
    <Helmet title='Контактые данные' />
    <BreadCrumbs crumbs={[['/contacts']]} />
    <Contacts
      email={email}
      phones={phones}
      address={address}
      coordinates={coordinates}
    />
  </>
);

export default ContactsRoute;
